import { mapState } from "vuex";
export default {
  computed: {
    ...mapState({
      info: state => state.user
    }),
    fullName() {
      return this.firstName + ' ' + this.lastName
    }
  },
  methods: {
    isOwnerFn(id) {
      if(!id) return false
      if(id === this.info.userId) return true
      return false
    }
  }
}